module.exports = __webpack_public_path__ + "img/cart.ebf0eefb.svg";